module.exports = __webpack_public_path__ + "img/treePicture_resize.5435edad.jpg";